var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.imgList.length)?_c('swiper',{ref:"mySwiper",staticClass:"mySwiper",attrs:{"options":_vm.swiperOption}},[_vm._l((_vm.imgList),function(item,i){return _c('swiper-slide',{key:i},[_c('img',{attrs:{"src":item.carouselUrl}})])}),_c('div',{staticClass:"pagination",attrs:{"slot":"pagination","id":"pagination"},slot:"pagination"})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }